import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { Engagement } from './shared/models/engagement.model';
import { SearchBarService } from 'src/app/shared/components/search-bar/search-bar.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';

@Injectable({
  providedIn: 'root',
})
export class EngagementHistoryService {
  constructor(
    private httpClient: HttpClient,
    private errorHandlingService: ErrorHandlingService,

    private alcmeonContextService: AlcmeonContextService,
    private searchBarService: SearchBarService
  ) {}

  retrieveEngagements = (): Observable<HttpResponse<Engagement[]>> => {
    const body = this.searchBarService.buildCriteria();
    return this.httpClient
      .post<Engagement[]>(`${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/engagement-history`, body, {
        observe: 'response',
      })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  };
}
